var _path, _path2, _path3, _image, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFantlogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2050 638",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.6353,
    y1: 393.1847,
    x2: 609.1607,
    y2: 268.7642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00E68C",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#00E68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9641,
    style: {
      stopColor: "#00E68C",
      stopOpacity: 0.3627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E68C",
      stopOpacity: 0.3
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M493.1,379.3c-44,16.2-93.1,18.2-138.4,7c-37.6-8.6-72-26.3-107.7-38.8 c-56.7-20.1-85.2,0.1-122.1,42.3c14.7-35.9,46.3-77,109.8-71.9c37,2.9,71.5,14.1,110.8,19.7c53.5,7.7,103.6,2.5,153.4-21.1 c50.7-20.2,92.9-70.7,91.2-125.1C597.4,233.8,601.6,333.3,493.1,379.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111192034065083810870000004577641201871409568_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.0168,
    y1: 458.6473,
    x2: 637.0076,
    y2: 352.9419
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1D1D1B",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#1D1D1B",
      stopOpacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    style: {
      stopColor: "#1D1D1B",
      stopOpacity: 0.3
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000111192034065083810870000004577641201871409568_)",
    d: "M466.8,489.9c-66,4.1-123.5-28.7-154-81.3 C416.4,500,620.7,427.9,611,277.5C643.1,376.2,570.6,483.5,466.8,489.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146472346108062627490000017096731824379048865_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.7793,
    y1: 250.072,
    x2: 525.5955,
    y2: 250.072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF2261"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#FF2261",
      stopOpacity: 0.1
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000146472346108062627490000017096731824379048865_)",
    d: "M345.5,337.7L345.5,337.7 c-3.9-95.9,82.4-174.7,180.1-158.9c-109.6-52-234.8,27-234.8,148.4C308.4,330.9,326.4,334.9,345.5,337.7z"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 236,
    height: 176,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOwAAACwCAYAAAAMn4KYAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA9pJREFUeNrs3DGO00ocwOFx2Cy0 tOgdYa/BPV65B6ACakSBREmaJ1HQUb2KjlPsERAFV0CaECQEkbHHM2PvbjL+PskKZLMg7fDTf+w4 hAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAALAS15urzk8BTlOXE+wu3uz9qOBMgh0iYjijYEUM9xzsIdbN0W8XiU/EcDfB9gkYTizYB4Vx ihhOINg5cYoY7ijYi8IA7zRiISPYP7FuM0PbLxSmiKHQxdi0TUTWJeLrCsLsloo49VaUmGk12E1l NCcZ8VDM4qXFCdv1Ytv3XrM/94ihpWD7sXUDsZ1ixEJm1VvifSK2+4y4JuSf2+FouVlTsDkR10Rb GrEJy7qDvd5cPR4JM/XYJZ4LI+fDYeGIhcwqJ+yDiThzpm7OFM6JuGQyzw0Zmgo297ncmHMiXmJ7 vRcprQc7FOTceGvPh4em71C0WSHv4s13S02rE3Ys1qXjzYm4v53N3ULXXvCCswj2YiLSnHBvewKX TOOx56CZYPtR7iuna0nQpRGXhhycy9JisNuCWMe+Fm5xGz03ZFhVsKUx50Y8d/oKltWfw+ZM1Tkh 12yn505faCrYy6NIYkaEsTLwmohrp7BoaTrYoQhT8caCKRwKvjYU3dxwoQnd9ebqaS/O1BSNiXhL t9KhMOCS2yJ/P+7izTfLTEsTdmw73I8wVsS7xHY59/3fkJjC0EywD3uhxYyAc0Otibh28u5ti1nL hJ3a/saFA56KuOacV7CsZsLGRJhT0zb161AYcW2kudtlaDrYsSkbKgJOXVmOlQHnbJOh2S3x2IWl 1PY4jlyYqj0XXuJGjSBY1rolnoo49T0hlE3fpe62siWmSZvdl3/fHB4f/Qq3/3h8XPaOhxnH9uj1 26Pvuxz4c4f+nu3IcTlxHL8Ompqw4RDtq+Mnr/95/7xgoqYuUOVeaQ4FU7f21kc4e39/VvTrm8F/ 5JURx4EY55zbFp//7uLNZ8tMu8EOmY449+ryWMQ58caa89pDsJ8sM+sK9vYjzpmmU7dChpFg/7fM CDYz4kPAL0L+HVMl57dZ2+RDsB8tM4KdN4VfhPK7qFKfCoqJYD9YZgR7exGHUP5+7ejW+BDsf5YZ wd5BxCPTuOiDBYdg31lmBHu/0/hlyL9K/NYyI9gTnMYDW+ufwb62zAj2XGJ+8sx/JE4zfggwANyQ jd3MrxQ9AAAAAElFTkSuQmCC",
    transform: "matrix(1 0 0 1 290 162)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M723.9,193.6v37h54.9v30.6h-54.9v80.4h-34.5V163h107.3v30.6H723.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.7,341.7L873.3,163h24.3l76.6,178.8h-36l-16.9-39.6h-71.8l-16.9,39.6H796.7z M862.6,271.5H908l-22.7-52.9L862.6,271.5z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.4,163h24.3l99.6,116.4V163h34.5v178.8h-24.3l-99.6-116.4v116.4h-34.5V163z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.2,163v30.6H1287v148.1h-34.5V193.6h-47.2V163H1334.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.3,341.7L1416,163h24.3l76.6,178.8h-36l-16.9-39.6h-71.8l-16.9,39.6H1339.3z M1405.2,271.5h45.5l-22.7-52.9 L1405.2,271.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1562.3,294c10.2,11.2,25.8,19.7,42.1,19.7c15.3,0,26-9.4,26-22.5c0-23-33.2-25.8-57.2-39.8c-14-8.2-25.3-20.4-25.3-40.6 c0-31.9,29.4-50.3,59-50.3c18.1,0,35,4.3,51.8,16.9l-17.9,25.5c-7.2-6.6-19.2-11.7-30.9-11.7c-13,0-27.6,5.6-27.6,19.4 c0,28.9,82.5,19.9,82.5,80.2c0,31.7-28.3,53.6-60.5,53.6c-24,0-46.2-10-64.6-26.8L1562.3,294z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1779.8,260.8v81h-34.5v-81l-61.3-97.8h39.3l39.3,62.8l39.1-62.8h39.3L1779.8,260.8z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.8,397.5c-29.7,0-50.1,18.5-50.1,46.8c0,28.3,20.4,46.8,50.1,46.8c29.7,0,50.1-18.5,50.1-46.8 C1159.9,416,1139.5,397.5,1109.8,397.5z M1109.8,469.6L1109.8,469.6c-16.7,0-28.2-10-28.2-25.3c0-15.3,11.5-25.3,28.2-25.3 c0,0,0,0,0,0c16.7,0,28.2,10,28.2,25.3C1138,459.6,1126.5,469.6,1109.8,469.6z M736.4,398.5h-47.3V490h47.3 c30.4,0,47.6-22,47.6-45.7S767.3,398.5,736.4,398.5z M736.4,469.7h-25.5v-50.9h25.5c16.6,0,25.6,12.3,25.6,25.4 C762,457.4,752.7,469.7,736.4,469.7z M847.4,398.5h-53.8V490h21.9v-22.9c0,0,11.8,0,31.8,0s35.5-14.4,35.5-34.5 S867.2,398.5,847.4,398.5z M846.3,446.8h-30.8v-28.4h30.8C865.3,418.2,865.4,446.9,846.3,446.8z M1038.5,398.5l-19.1,56l-20.6-56 h-27.8l-20.6,56l-19.1-56h-22.2l28.9,91.5h21.8l25-68.4l25,68.4h21.8l28.9-91.5H1038.5z M1412.9,398.5h-47.3V490h47.3 c30.4,0,47.6-22,47.6-45.7S1443.7,398.5,1412.9,398.5z M1412.8,469.7h-25.5v-50.9h25.5c16.6,0,25.6,12.3,25.6,25.4 C1438.4,457.4,1429.2,469.7,1412.8,469.7z M1295.2,398.5h-21.9V490h82.9v-20.9h-61V398.5z M1252,407.8c-6.7-6.4-15.6-9.3-25.4-9.3 H1170V490h21.8v-27.4h34.4l12.9,27.4h24.1l-17-33.1C1263.1,447.6,1266,421.1,1252,407.8z M1224.9,442.8h-33.2v-24.3h33.2 c8.4-0.1,13.6,3.8,13.7,12C1238.5,438.2,1233.3,442.9,1224.9,442.8z M1733.8,452.6c0,8.3-2.2,13.4-6,16.9c-3.9,3.8-9.3,5.9-15.4,5.9 c-6.1,0-11.6-2.1-15.4-5.9c-3.8-3.5-6-8.6-6-16.9v-54.1h-17.5v52.8c0,13.9,4.2,23.6,11.7,30.4c7,6.3,17,9.4,27.3,9.4 c10.3,0,20.2-3.1,27.3-9.4c7.5-6.8,11.7-16.4,11.7-30.4v-52.8h-17.5V452.6z M1815.8,450.4c3.5-1.4,6.3-3.3,8.6-5.7 c4.5-4.7,7.1-11.8,7.1-19c0-7.2-2.6-14.3-7.1-19c-5.1-5.4-11.9-8.2-23.6-8.2h-34.1V490h17.5v-37.3h13.7l24.6,37.2h20.6L1815.8,450.4 z M1811,433.4c-2.1,2.2-5.1,3.7-11,3.7h-15.8v-22.9h15.8c6,0,9,1.4,11,3.7c1.9,2.1,3,4.8,3,7.8C1814,428.7,1812.9,431.3,1811,433.4z  M1516.2,492.9c0,1.5,0.4,3,1.1,4.4l7.6,13.8l7.6-13.8c0.7-1.3,1.1-2.8,1.1-4.4V429l-17.5-6.3V492.9z M1612.7,397.4 c-28,0-47.4,21-47.4,46.9c0,25.9,19.3,46.9,47.4,46.9c28,0,47.4-21,47.4-46.9C1660.1,418.3,1640.7,397.4,1612.7,397.4z  M1612.7,475.6c-17.1,0-29.9-14.1-29.9-31.3c0-17.2,12.7-31.3,29.9-31.3c17.1,0,29.9,14.1,29.9,31.3 C1642.6,461.5,1629.8,475.6,1612.7,475.6z M1482.8,398.5l7.1,13.3c0.8,1.5,2.3,2.4,3.9,2.4h62.3c1.6,0,3.1-0.9,3.9-2.4l7.1-13.3 H1482.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantlogoDark);
export default __webpack_public_path__ + "static/media/fantlogo-dark.e51ebd6627a3bb873e070098576af4cb.svg";
export { ForwardRef as ReactComponent };